<div class="product-list">
    <mat-accordion>
        <mat-expansion-panel [disabled]="!productsCounter">
            <mat-expansion-panel-header>
                {{ 'CONFIGURATION.PANEL.TITLE.LIST_OF_PRODUCTS' | translate }}
                <span *ngIf="productsCounter">&nbsp;({{ productsCounter }})</span>
            </mat-expansion-panel-header>
            <div class="list-items">
                <div class="list-item" *ngFor="let group of productListViewModel">
                    <ng-container *ngIf="group.products?.length">
                        <app-product-group
                            [products]="group.products"
                            [translationKey]="group.translationKey"
                        ></app-product-group>
                    </ng-container>
                </div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
    <div class="list-progress" *ngIf="productListService.isProductListLoading$ | async">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>
